import React from 'react';

const UsageContentsUserSearch = ({
    value,
    onChange,
    onSubmit,
    searching,
    candidates,
    onSelectUser,
    formRef,
    onReset
}) => (
    <>
        <form ref={formRef} className="usage-contents-search" onSubmit={onSubmit}>
            <label htmlFor="usage-contents-user-name">이름</label>
            <input
                id="usage-contents-user-name"
                type="text"
                value={value}
                onChange={(event) => onChange(event.target.value)}
                placeholder="회원 이름 입력"
                autoComplete="off"
                autoFocus
            />
            <button
                type="button"
                className="usage-contents-search-reset"
                onClick={onReset}
            >
                초기화
            </button>
            <button type="submit" disabled={searching}>
                {searching ? '검색 중...' : '검색'}
            </button>
        </form>

        {candidates.length > 1 && (
            <div className="usage-contents-candidates">
                <span>검색된 회원이 여러 명입니다. 조회할 회원을 선택하세요.</span>
                <div className="usage-contents-candidate-list">
                    {candidates.map((user, index) => (
                        <button
                            key={`${user.user_id}-${user.stCode}-${index}`}
                            type="button"
                            onClick={() => onSelectUser(user)}
                        >
                            <strong>{user.user_name || '(이름 없음)'}</strong>
                            <small>{user.user_id} / {user.stCode || '코드 없음'} / {user.bill_id}</small>
                        </button>
                    ))}
                </div>
            </div>
        )}
    </>
);

export default UsageContentsUserSearch;
